import script from "./EmptyState.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmptyState.vue?vue&type=script&lang=ts&setup=true"

import "./EmptyState.vue?vue&type=style&index=0&id=6c270346&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c270346"]])

export default __exports__